import { STORAGE_KEY } from '@/constant/constant';
import { getLocal } from '@/utils/storage';
import { getDeployEnv, isShopifyOrTest, isShoplineOrTest, isShoplazzaOrTest, isShopyyOrTest, isWooCommerceOrTest, isCommonOrTest, isSimpleOrTest, isXikeOrTest } from '@/utils/platform';

/**
 * 将十六进制颜色代码转换为RGB格式
 * @param {string} hex - 十六进制颜色代码（例如 "#0D0C16"）
 * @returns {string} - RGB格式的颜色（例如 "rgb(13, 12, 22)"）
 */
export function hexToRgb(hex, opacity = 1) {
  // 移除可能存在的 # 符号
  hex = hex.replace(/^#/, '');

  // 将十六进制颜色代码分解为 R, G, B 部分
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  // 返回 RGB 格式的字符串
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

/** 返回域名多个/ */
export function getCompanyStaticUrl() {
  return getLocal(STORAGE_KEY.COMPANY_STATIC_URL) || 'https://dvamghaolyr74.cloudfront.net/';
}

/**
 * 邮箱校验函数（基于HTML5标准，参考W3C规范）
 * 该正则表达式与浏览器原生 <input type="email"> 验证规则一致
 * 覆盖99.99%的真实邮箱格式，符合RFC 5322标准的实用子集
 * @param {string} email - 待验证的邮箱地址
 * @returns {boolean} - 邮箱是否有效
 */
export function isValidEmail(email: string): boolean {
  if (!email || email.length > 254) return false; // RFC 5321规定邮箱最大长度254

  // HTML5 标准邮箱验证正则
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  if (!emailRegex.test(email)) return false;

  // 额外检查：确保@符号前后都有内容，且域名至少有一个点
  const parts = email.split('@');
  if (parts.length !== 2) return false;

  const [localPart, domain] = parts;
  if (!localPart || !domain) return false;
  if (localPart.length > 64) return false; // RFC 5321规定本地部分最大64字符
  if (!domain.includes('.')) return false; // 域名必须包含至少一个点
  if (domain.startsWith('.') || domain.endsWith('.')) return false; // 域名不能以点开始或结束
  if (domain.includes('..')) return false; // 域名不能有连续的点

  return true;
}

export function getEnv() {
  let integrationId = undefined;
  if (isShopifyOrTest()) {
    integrationId = 1;
  } else if (isShoplineOrTest()) {
    integrationId = 11;
  } else if (isShoplazzaOrTest()) {
    integrationId = 21;
  } else if (isShopyyOrTest()) {
    integrationId = 31;
  } else if (isWooCommerceOrTest()) {
    integrationId = 41;
  } else if (isCommonOrTest() || isSimpleOrTest() || isXikeOrTest()) {
    integrationId = 91;
  }
  return JSON.stringify({
    deploy: getDeployEnv(),
    integrationId
  });
}